<app-header [searchInp]="searchParam"></app-header>
<ul class="breadcrumb-ul">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/" aria-label="Go to home">
                <mat-icon aria-hidden="false" aria-label="Home icon" fontIcon="home"></mat-icon>
            </a>
        </li>
        <li class="breadcrumb-item">Search</li>
    </ol>
</ul>
<section class="sidebar" id="otb-layout">
    <div class="row">
        <div class="menu-div">
            <div class="side-menu-list">
                <ul class="menu-items">
                    <h6 (click)="openFilter()">Filters<span
                            *ngIf="showFilterIcon"><mat-icon>filter_alt</mat-icon></span></h6>
                    <div *ngIf="showFilters" class="filter-block">
                        <div class="close" (click)="closeFilter()">Close <mat-icon>close</mat-icon></div>
                        <div class="filters">
                            <div class="list-block">
                                <h6 class="filter-headings">Tax Types</h6>
                                <div *ngFor="let type of taxTypes">
                                    <mat-checkbox [(ngModel)]="type.selected" (click)="enableApply()">{{ type.name
                                        }}</mat-checkbox>
                                </div>
                            </div>
                            <div class="list-block">
                                <h6 class="filter-headings">Categories</h6>
                                <div *ngFor="let opt of categories">
                                    <mat-checkbox [(ngModel)]="opt.selected" (click)="enableApply()">{{ opt.name
                                        }}</mat-checkbox>
                                </div>
                            </div>
                        </div>
                        <button class="apply-btn" matButton="filled" [disabled]="!showApply"
                            (click)="filterIt()">Apply</button>
                    </div>
                </ul>
            </div>
        </div>

        <div class="div-content">

            <div class="side-menu-content">
                <div class="content">
                    <h3>Search Results</h3>
                    <p>{{count}} results found for '{{searchParam}}'</p>
                    <div *ngIf="count>0; else elseBlock">
                        <div *ngIf="labels.length>0">
                            <ul class="filter-label">
                                <li class="filter-li" *ngFor="let item of labels">
                                    <a routerLink={{item.route}}>
                                        <span [innerHTML]="item.label | highlight: searchParam"></span>
                                        <span *ngIf="item.parent">of
                                            <span [innerHTML]="item.parent | highlight: searchParam"></span>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                            <mat-paginator [length]="filteredLabels.length" [pageSize]="6"
                                (page)="onLabelChange($event)">
                            </mat-paginator>
                            <hr>
                        </div>
                        <div *ngIf="paginatedItems.length>0">
                            <div class="content-div">
                                <div class="card-row page" *ngFor="let content of paginatedItems"
                                    (click)="routeToPage(content.route)">
                                    <h6 [innerHTML]="content.section | highlight: searchParam"></h6>
                                    <p [innerHTML]="content.match | highlight: searchParam"></p>
                                    <div class="specification">
                                        <span>Jan 2, 2025</span>
                                        <span>in <span class="page-tab">{{content.tab}}</span></span>
                                    </div>
                                </div>
                            </div>
                            <mat-paginator [length]="filteredContent.length" [pageSize]="5"
                                (page)="onPageChange($event)">
                            </mat-paginator>
                        </div>
                    </div>
                    <ng-template #elseBlock>
                        <p class="no-result">No results found!</p>
                    </ng-template>
                </div>
            </div>
            <div class="rating">
                <app-rating [rating]="0"></app-rating>
            </div>
        </div>
    </div>
</section>
<app-footer></app-footer>